import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app';
import ContextProvider from './app/context';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ContextProvider>
      <App />
    </ContextProvider>
  </React.StrictMode>
)
